import { render, staticRenderFns } from "./ConfigTasksList.vue?vue&type=template&id=90753e38&scoped=true&"
import script from "./ConfigTasksList.vue?vue&type=script&lang=js&"
export * from "./ConfigTasksList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTasksList.vue?vue&type=style&index=0&id=90753e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90753e38",
  null
  
)

export default component.exports